import BaseModel from './base-model';

/**
 * format:
 * @COMMON_NAME: "Accenture UI Key User PIN"
 * @REL_ATTR: "400114"
 * @id: "400114"
 */
export default class AccessType extends BaseModel {
  constructor(opts = {}) {
    super(opts);
  }
}
